// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { create_tree_js, get_contest_matches_js } from "sequent-core";
export var createTree = function (areas, areaContests) {
    try {
        return create_tree_js(areas, areaContests);
    }
    catch (error) {
        console.log(error);
        throw error;
    }
};
export var getContestMatches = function (tree, contestId) {
    try {
        return get_contest_matches_js(tree, contestId);
    }
    catch (error) {
        console.log(error);
        throw error;
    }
};
